export default function makeActionCreator(type, ...argNames) {
  return function actioncreator(...args) {
    const action = { type }
    argNames.forEach((arg, index) => {
      action[argNames[index]] = args[index]
    })
    return action
  }
}



// WEBPACK FOOTER //
// ./src/actions/creator.js